module.exports = __webpack_public_path__ + "img/dr-max.ce541134.png";